import { fetcher } from '../utils'
import { ComponentMessageVO } from '@repo/types'
import { ComponentOrderMessageVO } from '@repo/types/src/types/ComponentOrderMessageVO'

export default async (input: ComponentOrderMessageVO): Promise<ComponentMessageVO> =>
  fetcher(`/api/chats/order/send`, 'POST', input)
